export default {
  tab: 'Postes surveillés et suivis',
  searchBox: {
    placeholder: 'Recherche par emplacement',
    enterToSearch: 'Appuyez sur ⏎ pour rechercher',
  },
  allStatus: 'Tous les types',
  watching: 'Surveillé',
  following: 'Suivi',
  none: 'Aucun',
  searchRecruiters: 'Recherche par recruteur',
  recruiters: 'Recruteurs',
  recruiter: 'Recruteur',
  selectOption: 'Sélectionner le type',
  followed: 'Suivi',
  watched: 'Surveillé',
};
